import React, { useEffect, useState } from "react";
import { HeroSm, MyInput, MySelect, NavBar, Spinner } from "../../components";
import $ from "jquery";
import { Slang, passwordFormatReg } from "../../helpers";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import config from "../../config";
import Dashboard from "../../layouts/dashboard";

const Profile = () => {
    const [loadPage, setLoadPage] = useState(true);

    useEffect(() => {
        let tim1 = setTimeout(() => {
            setLoadPage(false);
        }, 100);

        return () => {
            clearInterval(tim1);
        };
    }, []);

    return (
        <>
            {loadPage ? (
                <>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100%",
                            position: "fixed",
                            left: 0,
                            top: 0,
                        }}
                    >
                        <Spinner color={"success"} size={3} />
                    </div>
                </>
            ) : (
                <Main />
            )}

            {/*<Helmet>*/}
            {/*	/!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
            {/*	<title>Register your Business</title>*/}
            {/*	<link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
            {/*	<link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
            {/*	<link rel="stylesheet" href="./assets/css/_theme.css" />*/}

            {/*	<script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/prism/prism.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/theme.min.js"></script>*/}

            {/*</Helmet>*/}
        </>
    );
};

export default Profile;

const Main = () => {
    const [passwordError, setPasswordError] = useState(null);
    const [passwordMatchError, setPasswordMatchError] = useState(null);
    const [submitted1, setSubmitted1] = useState(false);
    const [submitted2, setSubmitted2] = useState(false);
    const [countries, setCountries] = useState(null);
    const [categories, setCategories] = useState(null);
    const [code, setCode] = useState("Empty");

    const lang1 = Slang("Profile");
    const lang2 = Slang("Profile.password");
    const lang3 = Slang("Profile.info");
    const lang4 = Slang("Profile.language");
    const passwordValLang = Slang("Validation.password");

    const [passwordData, setPasswordData] = useState({
        password: "",
        confirm_password: "",
        old_password: ""
    });

    const [formData, setFormData] = useState({
        email1: "",
        email: "",
        first_name: "",
        last_name: "",
        country: "",
        language: "",
        phone_num1: "",
        phone_num2: "",
        poste: "",
        department: "",
        enterprise: "",
        organisation: "",
        site_web: "",
    });

    const token = useSelector((state) => state.auth.token.value);
    const ip = sessionStorage.getItem('ip')

    // console.log('userInfos', userInfo);

    const getCategories = async () => {
        const { data } = await axios.get(`${config.apiUrl}/categories`, {});
        setCategories(data.data.categories);
    };

    const getCountries = async () => {
        const { data } = await axios.get(`${config.get_json_json}`, {});
        setCountries(data.countries);
    };

    const handleChangeCountry = (e) => {
        const { name, value } = e.target;

        setCode(countries.filter((country) => country.name === value)[0]);
        setFormData({ ...formData, [name]: value });
    };

    const fetchUserInfo = async () => {
        try {
            const response = await axios.get('https://abn.happynessarl.com/api/v1/verify/user', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = response.data.data;
            setFormData({
                ...formData,
                email1: data.email,
                first_name: data.full_name.split(" ")[0],
                last_name: data.full_name.split(" ")[1],
                phone_num1: data.phone,
                uuid: data.uuid
            })
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    const handleChange1 = (e) => {
        const { name, value } = e.target;

        if (name === "password") {
            validatePassword(value);
        }

        if (name === "confirm_password") {
            validateConfirmPassword(passwordData.password, value);
        }

        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleChange2 = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted2(true)
        try {
            await axios.put(`https://abn.happynessarl.com/api/v1/user/updated/${formData.uuid}`, { ...formData, ip }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            setSubmitted2(false)
            toast.success(lang3('success'));
        } catch (error) {
            toast.error(lang3('error'));
            setSubmitted2(false)
            console.error(error);
        }
    }

    const updatePassword = async (e) => {
        e.preventDefault();
        try {
            setSubmitted1(true);
            await axios.post(
                'https://abn.happynessarl.com/api/v1/update/password',
                {
                    old_password: passwordData.old_password,
                    password: passwordData.password,
                    password_confirmation: passwordData.confirm_password,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setSubmitted1(false);
            setPasswordData({
                password: "",
                confirm_password: "",
                old_password: ""
            })
            toast.success(lang2('success')); // Display success toast

        } catch (error) {
            // Handle the error
            setSubmitted1(false);
            toast.error(lang2('error'));
            console.error(error);
        }
    };

    const validatePassword = (text) => {
        const result = passwordFormatReg(text);

        if (!result.size) {
            setPasswordError(passwordValLang("p1"));
        } else if (!result.lower) {
            setPasswordError(passwordValLang("p2"));
        } else if (!result.upper) {
            setPasswordError(passwordValLang("p3"));
        } else if (!result.number) {
            setPasswordError(passwordValLang("p4"));
        } else if (!result.special) {
            setPasswordError(passwordValLang("p5"));
        } else {
            setPasswordError(null);
        }
    };

    const validateConfirmPassword = (password, confirm) => {
        if (password !== confirm) {
            setPasswordMatchError(passwordValLang("p6"));
        } else {
            setPasswordMatchError(null);
        }
    };

    useEffect(() => {

        fetchUserInfo();
        getCountries();
        getCategories();

        const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

        $("body").append(`<script className="homescript">${script}</script>`);

        return () => {
            $(".homescript").remove();
        };
    }, []);

    return (
        <Dashboard sub = {true}>
            <main id="content" role="main">
                <div className="container content-space-6 content-space-t-lg-1 content-space-b-lg-3">
                    <div className="flex-grow-1 mx-auto" style={{ maxWidth: "100rem" }}>
                        <form onSubmit={updatePassword}>
                            <fieldset
                                style={{
                                    padding: 10,
                                    borderRadius: 5,
                                    color: "black",
                                    boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
                                    background: "white"
                                }}
                                className="border"
                            >
                                <legend className="fw-bold">{lang2('title')}</legend>

                                <div className="row">

                                    <div className="col-md-3 col-sm-12">
                                        <MyInput
                                            required={true}
                                            handleChange={handleChange1}
                                            label={lang2('t3')}
                                            value={passwordData.old_password}
                                            id="old_password"
                                            name="old_password"
                                            placeholder={lang2('t3')}
                                            type="password"
                                        />
                                    </div>

                                    <div className="col-md-3 col-sm-12">
                                        <MyInput
                                            required={true}
                                            handleChange={handleChange1}
                                            label={lang2('t1')}
                                            value={passwordData.password}
                                            id="password"
                                            name="password"
                                            placeholder={lang2('t1')}
                                            type="password"
                                            error={passwordError}
                                        />
                                    </div>

                                    <div className="col-md-3 col-sm-12">
                                        <MyInput
                                            required={true}
                                            handleChange={handleChange1}
                                            label={lang2('t2')}
                                            value={passwordData.confirm_password}
                                            id="confirm_password"
                                            name="confirm_password"
                                            placeholder={lang2('t2')}
                                            type="password"
                                            error={passwordMatchError}
                                        />
                                    </div>

                                    <div className="col-md-3 col-sm-12">
                                        <button type="submit" className="btn btn-primary btn-lg w-100 mt-5">
                                            {submitted1 ? <Spinner color="light" /> : lang2('btn')}
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                        <br />
                        <form onSubmit={handleSubmit}>
                            <fieldset
                                style={{
                                    padding: 10,
                                    borderRadius: 5,
                                    color: "black",
                                    boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
                                    marginBottom: "2vh",
                                    background: "white"
                                }}
                                className="border "
                            >
                                <legend className="fw-bold">{lang3('title1')}</legend>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            label={lang3('t1')}
                                            handleChange={handleChange2}
                                            required={true}
                                            id="email1"
                                            name="email1"
                                            value={formData?.email1}
                                            placeholder={lang3('t1')}
                                            type="email1"
                                        />
                                    </div>
                                </div>

                                <legend className="fw-bold">{lang3('title2')}</legend>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            required={true}
                                            label={lang3('t2')}
                                            handleChange={handleChange2}
                                            id="first_name"
                                            name="first_name"
                                            value={formData?.first_name}
                                            placeholder={lang3('t2')}
                                            type="text"
                                        />
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            required={true}
                                            label={lang3('t3')}
                                            handleChange={handleChange2}
                                            id="last_name"
                                            name="last_name"
                                            value={formData?.last_name}
                                            placeholder={lang3('t3')}
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <label
                                            className="form-label text-primary fw-bold"
                                            htmlFor="country"
                                        >
                                            {lang3('t4')}
                                        </label>
                                        <select
                                            name="country"
                                            id="country"
                                            onChange={handleChangeCountry}
                                            className="form-control form-control-lg"
                                        >
                                            <option value={null}> -- --</option>
                                            {countries !== null
                                                ? countries.map((country, idx) => (
                                                    <option key={idx} value={country.name}>
                                                        {country.emoji} ({country.dial_code})&nbsp;{" "}
                                                        {country.name}
                                                    </option>
                                                ))
                                                : null}
                                        </select>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <label
                                            className="form-label text-primary fw-bold"
                                            htmlFor="country"
                                        >
                                            {lang3('t5')}
                                        </label>
                                        <select
                                            name="language"
                                            id="language"
                                            onChange={handleChange2}
                                            className="form-control form-control-lg"
                                        >
                                            <option value={null}> -- --</option>
                                            <option value={lang4('t1')}>{lang4('t1')}</option>
                                            <option value={lang4('t2')}>{lang4('t2')}</option>
                                            <option value={lang4('t3')}>{lang4('t3')}</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            label={lang3('t6')}
                                            handleChange={handleChange2}
                                            id="phone_num1"
                                            name="phone_num1"
                                            value={formData?.phone_num1}
                                            placeholder={lang3('t6')}
                                            type="tel"
                                        />
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            label={lang3('t7')}
                                            handleChange={handleChange2}
                                            id="phone_num2"
                                            name="phone_num2"
                                            placeholder={lang3('t7')}
                                            type="tel"
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            label={lang3('t8')}
                                            handleChange={handleChange2}
                                            id="poste"
                                            name="poste"
                                            placeholder={lang3('t8')}
                                            type="text"
                                        />
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <MySelect
                                            id="department"
                                            name="department"
                                            label={lang3('t9')}
                                            handleChange={handleChange2}
                                        />
                                    </div>
                                </div>

                                <legend className="fw-bold">{lang3('title3')}</legend>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MySelect
                                            required={true}
                                            handleChange={handleChange2}
                                            id="enterprise"
                                            name="enterprise"
                                            label={lang3('t10')}
                                            values={categories}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            required={true}
                                            label={lang3('t11')}
                                            id="organisation"
                                            name="organisation"
                                            placeholder={lang3('t11')}
                                            handleChange={handleChange2}
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            label={lang3('t12')}
                                            id="site_web"
                                            name="site_web"
                                            placeholder={lang3('t12')}
                                            handleChange={handleChange2}
                                            type="text"
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <MyInput
                                            required={true}
                                            label={lang3('t13')}
                                            id="email"
                                            name="email"
                                            placeholder={lang3('t13')}
                                            handleChange={handleChange2}
                                            type="email"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-12">
                                    <button type="submit" className="btn btn-primary btn-lg mt-3">
                                        {submitted2 ? <Spinner color="light" /> : lang3('btn')}
                                    </button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </main>
        </Dashboard>
    );
};
